var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C0 2.46 2.46 0 5.5 0H16c2.21 0 4 1.79 4 4s-1.79 4-4 4H7.5a2.5 2.5 0 010-5H15v2H7.41c-.55 0-.55 1 0 1H16c1.1 0 2-.9 2-2s-.9-2-2-2H5.5C3.57 2 2 3.57 2 5.5S3.57 9 5.5 9H15v2H5.5C2.46 11 0 8.54 0 5.5z"
  })));
}
export default __webpack_public_path__ + "static/media/attachment.a448df8d.svg";
export { SvgAttachment as ReactComponent };